import * as d3 from 'd3-selection'
import gauge from './lib/gauge.js'
import labels from './lib/labels.js'
import wrapTitleRect from './lib/wrap-title-rect.js'

let count = 0

function getDimensions (layout) {
  if (layout === 'horizontal') {
    return {
      margin: {
        top: 10,
        left: 30,
        right: 30,
        bottom: 15
      },
      labelOffset: 0,
      labelHeight: 0
    }
  } else {
    return {
      margin: {
        top: 20,
        left: 7,
        right: 7,
        bottom: 15
      },
      labelOffset: 15,
      labelHeight: 0
    }
  }
}

export default function (container, data, opt) {
  if (!opt) {
    throw new Error('Options needed with gaugeHeight, width, height and fontSize')
  }
  var id = 'linear-gauge-' + (++count)
    , svg = d3.select(container)
                .selectAll('svg')
                .data([data])
    , layout = opt.width > opt.height ? 'horizontal' : 'vertical'
    , dimensions = getDimensions(layout)

  // The space designated for the entire gauge (excluding bottom labels), might include its current value and threshold labels
  dimensions.gaugeHeight = Math.max(0, opt.gaugeHeight)
  dimensions.gaugeWidth = Math.max(opt.width - dimensions.margin.left - dimensions.margin.right, 0)

  var enter = svg.enter()
                 .append('svg')
                   .attr('class', 'linear-gauge')
    , _svg = enter.merge(svg)
                  .attr('width', opt.width)
                  .attr('height', opt.height)
                  .classed('horizontal vertical', false)
                  .classed(layout, true)

  dimensions.dominantEdge = layout === 'horizontal' ? dimensions.gaugeWidth : dimensions.gaugeHeight

  _svg.call(gauge(id, dimensions))
      .call(labels(dimensions, opt.fontSize))
      .call(wrapTitleRect)

  // Update the size of the svg to include the margins, so the svg size can be accurately queried
  _svg.attr('height', dimensions.gaugeHeight + dimensions.labelHeight + dimensions.margin.top + dimensions.margin.bottom + dimensions.labelOffset)
      .attr('width', dimensions.gaugeWidth + dimensions.margin.left + dimensions.margin.right)

  return _svg
}
